import { render, staticRenderFns } from "./AddAddressModal.vue?vue&type=template&id=1651adba&scoped=true"
import script from "./AddAddressModal.vue?vue&type=script&lang=js"
export * from "./AddAddressModal.vue?vue&type=script&lang=js"
import style0 from "./AddAddressModal.vue?vue&type=style&index=0&id=1651adba&prod&scoped=true&lang=css"
import style1 from "./AddAddressModal.vue?vue&type=style&index=1&id=1651adba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1651adba",
  null
  
)

export default component.exports